<script lang="ts">
	import Notification from '../molecules/Notification.svelte'
	import { dismissNotification, notifications } from '../stores'
	import { fade, fly } from 'svelte/transition'

	interface Props {
		id?: string
		position?: string // for some cases, e.g., map, it could be necessary to use position: absolute
		notificationWidth?: string
		marginTop?: string
		top?: string
		target?: string | null // set default null to show general in the main component
		padding?: string
	}

	let {
		id = '',
		position = 'sticky',
		notificationWidth = '100%',
		marginTop = '3.125rem',
		top = '2rem',
		target = null,
		padding = '0 2rem 0 2rem'
	}: Props = $props()
</script>

{#if $notifications && $notifications.filter((notification) => notification.target === target).length > 0}
	<section
		in:fly={{ x: -1000, duration: 400 }}
		out:fade={{ duration: 400 }}
		{id}
		style="--ntfy-position: {position}; --ntfy-margin-top: {marginTop}; --ntfy-padding: {padding}; --ntfy-top: {top};"
	>
		{#each $notifications.filter((notification) => notification.target === target) as notification (notification.id)}
			<Notification
				message={notification.message}
				messageHint={notification.messageHint}
				type={notification.type}
				dismiss={notification.dismissible}
				width={notificationWidth}
				on:dismiss={() => dismissNotification(notification.id)}
			></Notification>
		{/each}
	</section>
{/if}

<style>
	section {
		display: flex;
		flex-direction: column;
		align-items: center;
		row-gap: 12px;
		justify-content: center;
		position: var(--ntfy-position);
		top: var(--ntfy-top);
		left: 0;
		right: 0;
		width: 100%;
		z-index: 1000;
		margin-top: var(--ntfy-margin-top);
		padding: var(--ntfy-padding);
		transition: padding 400ms ease-out;
		pointer-events: none;

		@media (width <= 1420px) {
			section {
				--ntfy-padding: 0 2rem 0 2rem;
			}
		}
	}
</style>
